const shirts = [
    "https://i.ibb.co/Chw9cTQ/8-shirt.png",
    "https://i.ibb.co/gvXXxBs/7-shirt.png",
    "https://i.ibb.co/mqjFDK5/6-shirt.png",
    "https://i.ibb.co/tPCLsxT/5-shirt.png",
    "https://i.ibb.co/3hvJDHW/4-shirt.png",
    "https://i.ibb.co/nn3c9pp/3-shirt.png",
    "https://i.ibb.co/7YkgvMY/2-shirt.png",
    "https://i.ibb.co/7Jk3yWC/1-shirt.png"
];
const trousers = [
    "https://i.ibb.co/5RqzLqC/1-trouser.png",
    "https://i.ibb.co/pX81Hz9/2-trouser.png",
    "https://i.ibb.co/gvb1hjc/3-trouser.png",
    "https://i.ibb.co/khNYS0P/4-trouser.png",
    "https://i.ibb.co/dkLLs0t/5-trouser.png",
    "https://i.ibb.co/CKMVxbX/6-trouser.png",
    "https://i.ibb.co/m8dkWtB/7-trouser.png",
    "https://i.ibb.co/y6RfSpW/8-trouser.png"
];
const shoes = [
    "https://i.ibb.co/rkbtKjR/1-shoes.png",
    "https://i.ibb.co/tDYyKqz/2-shoes.png",
    "https://i.ibb.co/RQyM4vq/3-shoes.png",
    "https://i.ibb.co/jWns53t/4-shoes.png",
    "https://i.ibb.co/2WCcvZy/5-shoes.png",
    "https://i.ibb.co/NsBCjJN/6-shoes.png",
    "https://i.ibb.co/B24PNBG/7-shoes.png",
    "https://i.ibb.co/ZcCPxvT/8-shoes.png"
];
const accessories = [
    "https://i.ibb.co/TtThcTG/1.png",
    "https://i.ibb.co/zsRSJcF/2.png",
    "https://i.ibb.co/WKF5Wms/3.png",
    "https://i.ibb.co/m6QyLLf/4.png",
    "https://i.ibb.co/f2ccgxq/5.png",
    "https://i.ibb.co/LSnnKyP/6.png",
    "https://i.ibb.co/RHgjVWY/7.png",
    "https://i.ibb.co/9HK8KsM/8.png"
];

const images = {shirts: shirts, trousers:trousers, shoes:shoes, accessories:accessories}

export default images;